import { render } from "./HotspotSwiper.vue?vue&type=template&id=1267876c&scoped=true&ts=true"
import script from "./HotspotSwiper.vue?vue&type=script&lang=ts"
export * from "./HotspotSwiper.vue?vue&type=script&lang=ts"

import "./HotspotSwiper.vue?vue&type=style&index=0&id=1267876c&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1267876c"]])

export default __exports__